import React from 'react';

import { Divider, Stack, Text, Tooltip } from 'shell/components';

const TooltipDemo = () => {
    return (
        <>
            <Text variant={'sh1'}>Tooltip</Text>

            <Tooltip content={'This appears when the user hovers or focuses on an element.'} type={'info'} />
            <Tooltip
                content={
                    <Text color={'inherit'} variant={'h5'}>
                        This appears when the user hovers or focuses on an element.
                    </Text>
                }
                type={'info'}
            />

            <Tooltip content={'This appears when the user hovers or focuses on an element.'} type={'alert'} />
            <Tooltip
                content={
                    <Text color={'inherit'} variant={'h5'}>
                        This appears when the user hovers or focuses on an element.
                    </Text>
                }
                type={'alert'}
            />

            <Tooltip
                title={
                    <Text color={'inherit'} variant={'p3'}>
                        This is tooltip renders a Text component.
                    </Text>
                }
            >
                <Text>Simple tooltip.</Text>
            </Tooltip>

            <Tooltip
                maxWidth={160}
                title={
                    <Stack divider={<Divider />} spacing={1}>
                        <Text color={'inherit'} variant={'p3'}>
                            This is also a tooltip.
                        </Text>
                        <Text color={'inherit'} variant={'p3'}>
                            {`It renders a Stack component, with Text components and a Divider. You have to make sure to
                            that the Text components use "color={'inherit'}"!`}
                        </Text>
                    </Stack>
                }
            >
                <Text>Complex tooltip.</Text>
            </Tooltip>
        </>
    );
};

export default TooltipDemo;
